export const UPLOAD_BATCH_STATUS_VALUES = [
  'Pending',
  'Validated',
  'Processing',
  'Rejected',
  'Completed',
  'Failed',
];

export const DEFAULT_UPLOAD_BATCH_LIST_FILTER = {
  query: '',
  filter: 'fileName',
  page: 1,
  limit: 10,
  sortBy: 'createdAt',
  sortOrder: 'desc',
};

export function applyStatusFilter(prevFilter, statusValue) {
  if (statusValue === 'all') {
    return {
      ...prevFilter,
      ...(prevFilter.filter === 'status' ? { filter: 'fileName', query: '' } : {}),
      page: 1,
    };
  }

  return {
    ...prevFilter,
    filter: 'status',
    query: statusValue,
    page: 1,
  };
}

export function applySearchFilter(prevFilter, searchProp, query) {
  return {
    ...prevFilter,
    filter: searchProp,
    query,
    page: 1,
  };
}

export function resolveStatusFilterFromSearch(query, statusValues = UPLOAD_BATCH_STATUS_VALUES) {
  const match = statusValues.find(
    (status) => status.toLowerCase() === query.trim().toLowerCase()
  );
  return match || 'all';
}
